export {PromptInputBody, type PromptInputBodyProps} from './PromptInputBody';
